import striveMark from './assets/strive-mark.png';
import React from 'react';
import './main.css';

import spotifyLogo from './spotify.svg';
import { useSelector, useDispatch } from 'react-redux';
import { useCookies } from 'react-cookie';
import RideInfo from './RideInfo';
import Passengers from './Passengers';

const profileText = value => typeof value === 'string' ? value.trim() : '';

function Navbar(props) {
  const connected = Boolean(useSelector(state => state.pax_refresh));
  const dispatch = useDispatch();
  const [cookies, , removeCookie] = useCookies(['pax_img', 'pax_name']);
  const imageUrl = profileText(cookies.pax_img);
  const displayName = profileText(cookies.pax_name) || 'Spotify listener';

  const logout = () => {
    for (const name of ['pax_name', 'pax_img', 'access_token', 'refresh_token']) {
      removeCookie(name, { path: '/' });
      // OAuth sets domain cookies; clear those as well as older host-only cookies.
      if (window.location.hostname === 'remote.strive.fm') {
        removeCookie(name, { path: '/', domain: 'remote.strive.fm' });
      }
    }
    dispatch({ type: 'Pax_Refresh', payload: { pax_refresh: '' } });
  };

  return (
    <div className={`remote_bar${props.live_pax || connected ? ' remote-bar-with-passengers' : ''}${connected ? ' remote-bar-with-account' : ''}`}>
      <div className="nav_top">
        <div className="brand-section">
          <img className="brand-logo" src={striveMark} alt="" width="27" height="27" />
          <span className="brand-text">strive<span className="brand-domain">.fm</span></span>
        </div>
        <div className="nav-actions">
          {(props.live_pax || connected) && <Passengers live={props.live_pax} self={props.passenger} driverName={props.driver_alias || props.driver_name} account={connected ? { name: displayName, imageUrl } : null} onLogout={logout} />}
          <RideInfo />
          {!connected && (
            <a className="spotify-connect-btn" href="https://remote.strive.fm/spotify_login" aria-label="Connect to Spotify">
              <img src={spotifyLogo} alt="" style={{ width: 16, height: 16 }} />
              Connect
            </a>
          )}
        </div>
      </div>
    </div>
  );
}

export default Navbar;
